/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as PublicRouteImport } from './routes/_public';
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index';
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard';
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding';
import { Route as AuthenticatedPreferencesRouteImport } from './routes/_authenticated/preferences';
import { Route as AuthenticatedPrivacyAndDataRouteImport } from './routes/_authenticated/privacy-and-data';
import { Route as AuthenticatedProductsRouteImport } from './routes/_authenticated/products';
import { Route as AuthenticatedWeightRouteImport } from './routes/_authenticated/weight';
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password';
import { Route as PublicLoginRouteImport } from './routes/_public/login';
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password';
import { Route as PublicSignUpRouteImport } from './routes/_public/sign-up';
import { Route as AuthenticatedAssistantChar123ConversationIdChar125RouteImport } from './routes/_authenticated/assistant/{-$conversationId}';
import { Route as AuthenticatedMealsNewRouteImport } from './routes/_authenticated/meals/new';
import { Route as AuthenticatedPlansIndexRouteImport } from './routes/_authenticated/plans/index';
import { Route as AuthenticatedPlansNewRouteImport } from './routes/_authenticated/plans/new';
import { Route as AuthenticatedResourcesIndexRouteImport } from './routes/_authenticated/resources/index';
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index';
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account';
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile';
import { Route as AuthenticatedTrackingIndexRouteImport } from './routes/_authenticated/tracking/index';
import { Route as AuthenticatedTrackingWeightRouteImport } from './routes/_authenticated/tracking/weight';
import { Route as AuthenticatedResourcesExercisesIndexRouteImport } from './routes/_authenticated/resources/exercises/index';
import { Route as AuthenticatedResourcesExercisesExerciseIdRouteImport } from './routes/_authenticated/resources/exercises/$exerciseId';
import { Route as AuthenticatedResourcesExercisesNewRouteImport } from './routes/_authenticated/resources/exercises/new';
import { Route as AuthenticatedResourcesMealsIndexRouteImport } from './routes/_authenticated/resources/meals/index';
import { Route as AuthenticatedResourcesMealsSavedMealIdRouteImport } from './routes/_authenticated/resources/meals/$savedMealId';
import { Route as AuthenticatedResourcesMealsNewRouteImport } from './routes/_authenticated/resources/meals/new';
import { Route as AuthenticatedResourcesProductsIndexRouteImport } from './routes/_authenticated/resources/products/index';
import { Route as AuthenticatedResourcesProductsNewRouteImport } from './routes/_authenticated/resources/products/new';
import { Route as AuthenticatedSettingsNutritionPlansIndexRouteImport } from './routes/_authenticated/settings/nutrition-plans/index';
import { Route as AuthenticatedSettingsNutritionPlansNewRouteImport } from './routes/_authenticated/settings/nutrition-plans/new';
import { Route as AuthenticatedTrackingCalendarIndexRouteImport } from './routes/_authenticated/tracking/calendar/index';
import { Route as AuthenticatedTrackingCalendarWeekRouteImport } from './routes/_authenticated/tracking/calendar/week';
import { Route as AuthenticatedTrackingMealsIndexRouteImport } from './routes/_authenticated/tracking/meals/index';
import { Route as AuthenticatedTrackingMealsManualRouteImport } from './routes/_authenticated/tracking/meals/manual';
import { Route as AuthenticatedTrackingMealsNewRouteImport } from './routes/_authenticated/tracking/meals/new';
import { Route as AuthenticatedTrackingMeasurementsIndexRouteImport } from './routes/_authenticated/tracking/measurements/index';
import { Route as AuthenticatedTrackingMeasurementsBodyMetricIdRouteImport } from './routes/_authenticated/tracking/measurements/$bodyMetricId';
import { Route as AuthenticatedTrackingWorkoutsIndexRouteImport } from './routes/_authenticated/tracking/workouts/index';
import { Route as AuthenticatedTrackingWorkoutsWorkoutIdRouteImport } from './routes/_authenticated/tracking/workouts/$workoutId';
import { Route as AuthenticatedTrackingWorkoutsActiveRouteImport } from './routes/_authenticated/tracking/workouts/active';
import { Route as AuthenticatedTrackingWorkoutsHistoryRouteImport } from './routes/_authenticated/tracking/workouts/history';
import { Route as AuthenticatedTrackingWorkoutsTemplatesTemplateIdRouteImport } from './routes/_authenticated/tracking/workouts/templates/$templateId';
import { Route as AuthenticatedTrackingWorkoutsTemplatesNewRouteImport } from './routes/_authenticated/tracking/workouts/templates/new';
import { Route as AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRouteImport } from './routes/_authenticated/tracking/workouts/templates/$templateId_.edit';

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedPreferencesRoute =
  AuthenticatedPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPrivacyAndDataRoute =
  AuthenticatedPrivacyAndDataRouteImport.update({
    id: '/privacy-and-data',
    path: '/privacy-and-data',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedProductsRoute = AuthenticatedProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedWeightRoute = AuthenticatedWeightRouteImport.update({
  id: '/weight',
  path: '/weight',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any);
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any);
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any);
const PublicSignUpRoute = PublicSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PublicRoute,
} as any);
const AuthenticatedAssistantChar123ConversationIdChar125Route =
  AuthenticatedAssistantChar123ConversationIdChar125RouteImport.update({
    id: '/assistant/{-$conversationId}',
    path: '/assistant/{-$conversationId}',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedMealsNewRoute = AuthenticatedMealsNewRouteImport.update({
  id: '/meals/new',
  path: '/meals/new',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedPlansIndexRoute = AuthenticatedPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedPlansNewRoute = AuthenticatedPlansNewRouteImport.update({
  id: '/plans/new',
  path: '/plans/new',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedResourcesIndexRoute =
  AuthenticatedResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/settings/account',
    path: '/settings/account',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingIndexRoute =
  AuthenticatedTrackingIndexRouteImport.update({
    id: '/tracking/',
    path: '/tracking/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingWeightRoute =
  AuthenticatedTrackingWeightRouteImport.update({
    id: '/tracking/weight',
    path: '/tracking/weight',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedResourcesExercisesIndexRoute =
  AuthenticatedResourcesExercisesIndexRouteImport.update({
    id: '/resources/exercises/',
    path: '/resources/exercises/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedResourcesExercisesExerciseIdRoute =
  AuthenticatedResourcesExercisesExerciseIdRouteImport.update({
    id: '/resources/exercises/$exerciseId',
    path: '/resources/exercises/$exerciseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedResourcesExercisesNewRoute =
  AuthenticatedResourcesExercisesNewRouteImport.update({
    id: '/resources/exercises/new',
    path: '/resources/exercises/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedResourcesMealsIndexRoute =
  AuthenticatedResourcesMealsIndexRouteImport.update({
    id: '/resources/meals/',
    path: '/resources/meals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedResourcesMealsSavedMealIdRoute =
  AuthenticatedResourcesMealsSavedMealIdRouteImport.update({
    id: '/resources/meals/$savedMealId',
    path: '/resources/meals/$savedMealId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedResourcesMealsNewRoute =
  AuthenticatedResourcesMealsNewRouteImport.update({
    id: '/resources/meals/new',
    path: '/resources/meals/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedResourcesProductsIndexRoute =
  AuthenticatedResourcesProductsIndexRouteImport.update({
    id: '/resources/products/',
    path: '/resources/products/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedResourcesProductsNewRoute =
  AuthenticatedResourcesProductsNewRouteImport.update({
    id: '/resources/products/new',
    path: '/resources/products/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsNutritionPlansIndexRoute =
  AuthenticatedSettingsNutritionPlansIndexRouteImport.update({
    id: '/settings/nutrition-plans/',
    path: '/settings/nutrition-plans/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsNutritionPlansNewRoute =
  AuthenticatedSettingsNutritionPlansNewRouteImport.update({
    id: '/settings/nutrition-plans/new',
    path: '/settings/nutrition-plans/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingCalendarIndexRoute =
  AuthenticatedTrackingCalendarIndexRouteImport.update({
    id: '/tracking/calendar/',
    path: '/tracking/calendar/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingCalendarWeekRoute =
  AuthenticatedTrackingCalendarWeekRouteImport.update({
    id: '/tracking/calendar/week',
    path: '/tracking/calendar/week',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingMealsIndexRoute =
  AuthenticatedTrackingMealsIndexRouteImport.update({
    id: '/tracking/meals/',
    path: '/tracking/meals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingMealsManualRoute =
  AuthenticatedTrackingMealsManualRouteImport.update({
    id: '/tracking/meals/manual',
    path: '/tracking/meals/manual',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingMealsNewRoute =
  AuthenticatedTrackingMealsNewRouteImport.update({
    id: '/tracking/meals/new',
    path: '/tracking/meals/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingMeasurementsIndexRoute =
  AuthenticatedTrackingMeasurementsIndexRouteImport.update({
    id: '/tracking/measurements/',
    path: '/tracking/measurements/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingMeasurementsBodyMetricIdRoute =
  AuthenticatedTrackingMeasurementsBodyMetricIdRouteImport.update({
    id: '/tracking/measurements/$bodyMetricId',
    path: '/tracking/measurements/$bodyMetricId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingWorkoutsIndexRoute =
  AuthenticatedTrackingWorkoutsIndexRouteImport.update({
    id: '/tracking/workouts/',
    path: '/tracking/workouts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingWorkoutsWorkoutIdRoute =
  AuthenticatedTrackingWorkoutsWorkoutIdRouteImport.update({
    id: '/tracking/workouts/$workoutId',
    path: '/tracking/workouts/$workoutId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingWorkoutsActiveRoute =
  AuthenticatedTrackingWorkoutsActiveRouteImport.update({
    id: '/tracking/workouts/active',
    path: '/tracking/workouts/active',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingWorkoutsHistoryRoute =
  AuthenticatedTrackingWorkoutsHistoryRouteImport.update({
    id: '/tracking/workouts/history',
    path: '/tracking/workouts/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingWorkoutsTemplatesTemplateIdRoute =
  AuthenticatedTrackingWorkoutsTemplatesTemplateIdRouteImport.update({
    id: '/tracking/workouts/templates/$templateId',
    path: '/tracking/workouts/templates/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingWorkoutsTemplatesNewRoute =
  AuthenticatedTrackingWorkoutsTemplatesNewRouteImport.update({
    id: '/tracking/workouts/templates/new',
    path: '/tracking/workouts/templates/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRoute =
  AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRouteImport.update({
    id: '/tracking/workouts/templates/$templateId_/edit',
    path: '/tracking/workouts/templates/$templateId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute;
  '/dashboard': typeof AuthenticatedDashboardRoute;
  '/onboarding': typeof AuthenticatedOnboardingRoute;
  '/preferences': typeof AuthenticatedPreferencesRoute;
  '/privacy-and-data': typeof AuthenticatedPrivacyAndDataRoute;
  '/products': typeof AuthenticatedProductsRoute;
  '/weight': typeof AuthenticatedWeightRoute;
  '/forgot-password': typeof PublicForgotPasswordRoute;
  '/login': typeof PublicLoginRoute;
  '/reset-password': typeof PublicResetPasswordRoute;
  '/sign-up': typeof PublicSignUpRoute;
  '/assistant/{-$conversationId}': typeof AuthenticatedAssistantChar123ConversationIdChar125Route;
  '/meals/new': typeof AuthenticatedMealsNewRoute;
  '/plans/new': typeof AuthenticatedPlansNewRoute;
  '/settings/account': typeof AuthenticatedSettingsAccountRoute;
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute;
  '/tracking/weight': typeof AuthenticatedTrackingWeightRoute;
  '/plans/': typeof AuthenticatedPlansIndexRoute;
  '/resources/': typeof AuthenticatedResourcesIndexRoute;
  '/settings/': typeof AuthenticatedSettingsIndexRoute;
  '/tracking/': typeof AuthenticatedTrackingIndexRoute;
  '/resources/exercises/$exerciseId': typeof AuthenticatedResourcesExercisesExerciseIdRoute;
  '/resources/exercises/new': typeof AuthenticatedResourcesExercisesNewRoute;
  '/resources/meals/$savedMealId': typeof AuthenticatedResourcesMealsSavedMealIdRoute;
  '/resources/meals/new': typeof AuthenticatedResourcesMealsNewRoute;
  '/resources/products/new': typeof AuthenticatedResourcesProductsNewRoute;
  '/settings/nutrition-plans/new': typeof AuthenticatedSettingsNutritionPlansNewRoute;
  '/tracking/calendar/week': typeof AuthenticatedTrackingCalendarWeekRoute;
  '/tracking/meals/manual': typeof AuthenticatedTrackingMealsManualRoute;
  '/tracking/meals/new': typeof AuthenticatedTrackingMealsNewRoute;
  '/tracking/measurements/$bodyMetricId': typeof AuthenticatedTrackingMeasurementsBodyMetricIdRoute;
  '/tracking/workouts/$workoutId': typeof AuthenticatedTrackingWorkoutsWorkoutIdRoute;
  '/tracking/workouts/active': typeof AuthenticatedTrackingWorkoutsActiveRoute;
  '/tracking/workouts/history': typeof AuthenticatedTrackingWorkoutsHistoryRoute;
  '/resources/exercises/': typeof AuthenticatedResourcesExercisesIndexRoute;
  '/resources/meals/': typeof AuthenticatedResourcesMealsIndexRoute;
  '/resources/products/': typeof AuthenticatedResourcesProductsIndexRoute;
  '/settings/nutrition-plans/': typeof AuthenticatedSettingsNutritionPlansIndexRoute;
  '/tracking/calendar/': typeof AuthenticatedTrackingCalendarIndexRoute;
  '/tracking/meals/': typeof AuthenticatedTrackingMealsIndexRoute;
  '/tracking/measurements/': typeof AuthenticatedTrackingMeasurementsIndexRoute;
  '/tracking/workouts/': typeof AuthenticatedTrackingWorkoutsIndexRoute;
  '/tracking/workouts/templates/$templateId': typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdRoute;
  '/tracking/workouts/templates/new': typeof AuthenticatedTrackingWorkoutsTemplatesNewRoute;
  '/tracking/workouts/templates/$templateId/edit': typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRoute;
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute;
  '/dashboard': typeof AuthenticatedDashboardRoute;
  '/onboarding': typeof AuthenticatedOnboardingRoute;
  '/preferences': typeof AuthenticatedPreferencesRoute;
  '/privacy-and-data': typeof AuthenticatedPrivacyAndDataRoute;
  '/products': typeof AuthenticatedProductsRoute;
  '/weight': typeof AuthenticatedWeightRoute;
  '/forgot-password': typeof PublicForgotPasswordRoute;
  '/login': typeof PublicLoginRoute;
  '/reset-password': typeof PublicResetPasswordRoute;
  '/sign-up': typeof PublicSignUpRoute;
  '/assistant/{-$conversationId}': typeof AuthenticatedAssistantChar123ConversationIdChar125Route;
  '/meals/new': typeof AuthenticatedMealsNewRoute;
  '/plans/new': typeof AuthenticatedPlansNewRoute;
  '/settings/account': typeof AuthenticatedSettingsAccountRoute;
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute;
  '/tracking/weight': typeof AuthenticatedTrackingWeightRoute;
  '/plans': typeof AuthenticatedPlansIndexRoute;
  '/resources': typeof AuthenticatedResourcesIndexRoute;
  '/settings': typeof AuthenticatedSettingsIndexRoute;
  '/tracking': typeof AuthenticatedTrackingIndexRoute;
  '/resources/exercises/$exerciseId': typeof AuthenticatedResourcesExercisesExerciseIdRoute;
  '/resources/exercises/new': typeof AuthenticatedResourcesExercisesNewRoute;
  '/resources/meals/$savedMealId': typeof AuthenticatedResourcesMealsSavedMealIdRoute;
  '/resources/meals/new': typeof AuthenticatedResourcesMealsNewRoute;
  '/resources/products/new': typeof AuthenticatedResourcesProductsNewRoute;
  '/settings/nutrition-plans/new': typeof AuthenticatedSettingsNutritionPlansNewRoute;
  '/tracking/calendar/week': typeof AuthenticatedTrackingCalendarWeekRoute;
  '/tracking/meals/manual': typeof AuthenticatedTrackingMealsManualRoute;
  '/tracking/meals/new': typeof AuthenticatedTrackingMealsNewRoute;
  '/tracking/measurements/$bodyMetricId': typeof AuthenticatedTrackingMeasurementsBodyMetricIdRoute;
  '/tracking/workouts/$workoutId': typeof AuthenticatedTrackingWorkoutsWorkoutIdRoute;
  '/tracking/workouts/active': typeof AuthenticatedTrackingWorkoutsActiveRoute;
  '/tracking/workouts/history': typeof AuthenticatedTrackingWorkoutsHistoryRoute;
  '/resources/exercises': typeof AuthenticatedResourcesExercisesIndexRoute;
  '/resources/meals': typeof AuthenticatedResourcesMealsIndexRoute;
  '/resources/products': typeof AuthenticatedResourcesProductsIndexRoute;
  '/settings/nutrition-plans': typeof AuthenticatedSettingsNutritionPlansIndexRoute;
  '/tracking/calendar': typeof AuthenticatedTrackingCalendarIndexRoute;
  '/tracking/meals': typeof AuthenticatedTrackingMealsIndexRoute;
  '/tracking/measurements': typeof AuthenticatedTrackingMeasurementsIndexRoute;
  '/tracking/workouts': typeof AuthenticatedTrackingWorkoutsIndexRoute;
  '/tracking/workouts/templates/$templateId': typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdRoute;
  '/tracking/workouts/templates/new': typeof AuthenticatedTrackingWorkoutsTemplatesNewRoute;
  '/tracking/workouts/templates/$templateId/edit': typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/_public': typeof PublicRouteWithChildren;
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute;
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute;
  '/_authenticated/preferences': typeof AuthenticatedPreferencesRoute;
  '/_authenticated/privacy-and-data': typeof AuthenticatedPrivacyAndDataRoute;
  '/_authenticated/products': typeof AuthenticatedProductsRoute;
  '/_authenticated/weight': typeof AuthenticatedWeightRoute;
  '/_public/forgot-password': typeof PublicForgotPasswordRoute;
  '/_public/login': typeof PublicLoginRoute;
  '/_public/reset-password': typeof PublicResetPasswordRoute;
  '/_public/sign-up': typeof PublicSignUpRoute;
  '/_authenticated/': typeof AuthenticatedIndexRoute;
  '/_authenticated/assistant/{-$conversationId}': typeof AuthenticatedAssistantChar123ConversationIdChar125Route;
  '/_authenticated/meals/new': typeof AuthenticatedMealsNewRoute;
  '/_authenticated/plans/new': typeof AuthenticatedPlansNewRoute;
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute;
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute;
  '/_authenticated/tracking/weight': typeof AuthenticatedTrackingWeightRoute;
  '/_authenticated/plans/': typeof AuthenticatedPlansIndexRoute;
  '/_authenticated/resources/': typeof AuthenticatedResourcesIndexRoute;
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute;
  '/_authenticated/tracking/': typeof AuthenticatedTrackingIndexRoute;
  '/_authenticated/resources/exercises/$exerciseId': typeof AuthenticatedResourcesExercisesExerciseIdRoute;
  '/_authenticated/resources/exercises/new': typeof AuthenticatedResourcesExercisesNewRoute;
  '/_authenticated/resources/meals/$savedMealId': typeof AuthenticatedResourcesMealsSavedMealIdRoute;
  '/_authenticated/resources/meals/new': typeof AuthenticatedResourcesMealsNewRoute;
  '/_authenticated/resources/products/new': typeof AuthenticatedResourcesProductsNewRoute;
  '/_authenticated/settings/nutrition-plans/new': typeof AuthenticatedSettingsNutritionPlansNewRoute;
  '/_authenticated/tracking/calendar/week': typeof AuthenticatedTrackingCalendarWeekRoute;
  '/_authenticated/tracking/meals/manual': typeof AuthenticatedTrackingMealsManualRoute;
  '/_authenticated/tracking/meals/new': typeof AuthenticatedTrackingMealsNewRoute;
  '/_authenticated/tracking/measurements/$bodyMetricId': typeof AuthenticatedTrackingMeasurementsBodyMetricIdRoute;
  '/_authenticated/tracking/workouts/$workoutId': typeof AuthenticatedTrackingWorkoutsWorkoutIdRoute;
  '/_authenticated/tracking/workouts/active': typeof AuthenticatedTrackingWorkoutsActiveRoute;
  '/_authenticated/tracking/workouts/history': typeof AuthenticatedTrackingWorkoutsHistoryRoute;
  '/_authenticated/resources/exercises/': typeof AuthenticatedResourcesExercisesIndexRoute;
  '/_authenticated/resources/meals/': typeof AuthenticatedResourcesMealsIndexRoute;
  '/_authenticated/resources/products/': typeof AuthenticatedResourcesProductsIndexRoute;
  '/_authenticated/settings/nutrition-plans/': typeof AuthenticatedSettingsNutritionPlansIndexRoute;
  '/_authenticated/tracking/calendar/': typeof AuthenticatedTrackingCalendarIndexRoute;
  '/_authenticated/tracking/meals/': typeof AuthenticatedTrackingMealsIndexRoute;
  '/_authenticated/tracking/measurements/': typeof AuthenticatedTrackingMeasurementsIndexRoute;
  '/_authenticated/tracking/workouts/': typeof AuthenticatedTrackingWorkoutsIndexRoute;
  '/_authenticated/tracking/workouts/templates/$templateId': typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdRoute;
  '/_authenticated/tracking/workouts/templates/new': typeof AuthenticatedTrackingWorkoutsTemplatesNewRoute;
  '/_authenticated/tracking/workouts/templates/$templateId_/edit': typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/dashboard'
    | '/onboarding'
    | '/preferences'
    | '/privacy-and-data'
    | '/products'
    | '/weight'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-up'
    | '/assistant/{-$conversationId}'
    | '/meals/new'
    | '/plans/new'
    | '/settings/account'
    | '/settings/profile'
    | '/tracking/weight'
    | '/plans/'
    | '/resources/'
    | '/settings/'
    | '/tracking/'
    | '/resources/exercises/$exerciseId'
    | '/resources/exercises/new'
    | '/resources/meals/$savedMealId'
    | '/resources/meals/new'
    | '/resources/products/new'
    | '/settings/nutrition-plans/new'
    | '/tracking/calendar/week'
    | '/tracking/meals/manual'
    | '/tracking/meals/new'
    | '/tracking/measurements/$bodyMetricId'
    | '/tracking/workouts/$workoutId'
    | '/tracking/workouts/active'
    | '/tracking/workouts/history'
    | '/resources/exercises/'
    | '/resources/meals/'
    | '/resources/products/'
    | '/settings/nutrition-plans/'
    | '/tracking/calendar/'
    | '/tracking/meals/'
    | '/tracking/measurements/'
    | '/tracking/workouts/'
    | '/tracking/workouts/templates/$templateId'
    | '/tracking/workouts/templates/new'
    | '/tracking/workouts/templates/$templateId/edit';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/dashboard'
    | '/onboarding'
    | '/preferences'
    | '/privacy-and-data'
    | '/products'
    | '/weight'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-up'
    | '/assistant/{-$conversationId}'
    | '/meals/new'
    | '/plans/new'
    | '/settings/account'
    | '/settings/profile'
    | '/tracking/weight'
    | '/plans'
    | '/resources'
    | '/settings'
    | '/tracking'
    | '/resources/exercises/$exerciseId'
    | '/resources/exercises/new'
    | '/resources/meals/$savedMealId'
    | '/resources/meals/new'
    | '/resources/products/new'
    | '/settings/nutrition-plans/new'
    | '/tracking/calendar/week'
    | '/tracking/meals/manual'
    | '/tracking/meals/new'
    | '/tracking/measurements/$bodyMetricId'
    | '/tracking/workouts/$workoutId'
    | '/tracking/workouts/active'
    | '/tracking/workouts/history'
    | '/resources/exercises'
    | '/resources/meals'
    | '/resources/products'
    | '/settings/nutrition-plans'
    | '/tracking/calendar'
    | '/tracking/meals'
    | '/tracking/measurements'
    | '/tracking/workouts'
    | '/tracking/workouts/templates/$templateId'
    | '/tracking/workouts/templates/new'
    | '/tracking/workouts/templates/$templateId/edit';
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/dashboard'
    | '/_authenticated/onboarding'
    | '/_authenticated/preferences'
    | '/_authenticated/privacy-and-data'
    | '/_authenticated/products'
    | '/_authenticated/weight'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_public/sign-up'
    | '/_authenticated/'
    | '/_authenticated/assistant/{-$conversationId}'
    | '/_authenticated/meals/new'
    | '/_authenticated/plans/new'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/profile'
    | '/_authenticated/tracking/weight'
    | '/_authenticated/plans/'
    | '/_authenticated/resources/'
    | '/_authenticated/settings/'
    | '/_authenticated/tracking/'
    | '/_authenticated/resources/exercises/$exerciseId'
    | '/_authenticated/resources/exercises/new'
    | '/_authenticated/resources/meals/$savedMealId'
    | '/_authenticated/resources/meals/new'
    | '/_authenticated/resources/products/new'
    | '/_authenticated/settings/nutrition-plans/new'
    | '/_authenticated/tracking/calendar/week'
    | '/_authenticated/tracking/meals/manual'
    | '/_authenticated/tracking/meals/new'
    | '/_authenticated/tracking/measurements/$bodyMetricId'
    | '/_authenticated/tracking/workouts/$workoutId'
    | '/_authenticated/tracking/workouts/active'
    | '/_authenticated/tracking/workouts/history'
    | '/_authenticated/resources/exercises/'
    | '/_authenticated/resources/meals/'
    | '/_authenticated/resources/products/'
    | '/_authenticated/settings/nutrition-plans/'
    | '/_authenticated/tracking/calendar/'
    | '/_authenticated/tracking/meals/'
    | '/_authenticated/tracking/measurements/'
    | '/_authenticated/tracking/workouts/'
    | '/_authenticated/tracking/workouts/templates/$templateId'
    | '/_authenticated/tracking/workouts/templates/new'
    | '/_authenticated/tracking/workouts/templates/$templateId_/edit';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  PublicRoute: typeof PublicRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_public': {
      id: '/_public';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof PublicRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/': {
      id: '/_authenticated/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/preferences': {
      id: '/_authenticated/preferences';
      path: '/preferences';
      fullPath: '/preferences';
      preLoaderRoute: typeof AuthenticatedPreferencesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/privacy-and-data': {
      id: '/_authenticated/privacy-and-data';
      path: '/privacy-and-data';
      fullPath: '/privacy-and-data';
      preLoaderRoute: typeof AuthenticatedPrivacyAndDataRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/products': {
      id: '/_authenticated/products';
      path: '/products';
      fullPath: '/products';
      preLoaderRoute: typeof AuthenticatedProductsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/weight': {
      id: '/_authenticated/weight';
      path: '/weight';
      fullPath: '/weight';
      preLoaderRoute: typeof AuthenticatedWeightRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_public/forgot-password': {
      id: '/_public/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof PublicForgotPasswordRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_public/login': {
      id: '/_public/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof PublicLoginRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_public/reset-password': {
      id: '/_public/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof PublicResetPasswordRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_public/sign-up': {
      id: '/_public/sign-up';
      path: '/sign-up';
      fullPath: '/sign-up';
      preLoaderRoute: typeof PublicSignUpRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_authenticated/assistant/{-$conversationId}': {
      id: '/_authenticated/assistant/{-$conversationId}';
      path: '/assistant/{-$conversationId}';
      fullPath: '/assistant/{-$conversationId}';
      preLoaderRoute: typeof AuthenticatedAssistantChar123ConversationIdChar125RouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/meals/new': {
      id: '/_authenticated/meals/new';
      path: '/meals/new';
      fullPath: '/meals/new';
      preLoaderRoute: typeof AuthenticatedMealsNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/plans/': {
      id: '/_authenticated/plans/';
      path: '/plans';
      fullPath: '/plans/';
      preLoaderRoute: typeof AuthenticatedPlansIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/plans/new': {
      id: '/_authenticated/plans/new';
      path: '/plans/new';
      fullPath: '/plans/new';
      preLoaderRoute: typeof AuthenticatedPlansNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/': {
      id: '/_authenticated/resources/';
      path: '/resources';
      fullPath: '/resources/';
      preLoaderRoute: typeof AuthenticatedResourcesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/';
      path: '/settings';
      fullPath: '/settings/';
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account';
      path: '/settings/account';
      fullPath: '/settings/account';
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile';
      path: '/settings/profile';
      fullPath: '/settings/profile';
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/': {
      id: '/_authenticated/tracking/';
      path: '/tracking';
      fullPath: '/tracking/';
      preLoaderRoute: typeof AuthenticatedTrackingIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/weight': {
      id: '/_authenticated/tracking/weight';
      path: '/tracking/weight';
      fullPath: '/tracking/weight';
      preLoaderRoute: typeof AuthenticatedTrackingWeightRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/exercises/': {
      id: '/_authenticated/resources/exercises/';
      path: '/resources/exercises';
      fullPath: '/resources/exercises/';
      preLoaderRoute: typeof AuthenticatedResourcesExercisesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/exercises/$exerciseId': {
      id: '/_authenticated/resources/exercises/$exerciseId';
      path: '/resources/exercises/$exerciseId';
      fullPath: '/resources/exercises/$exerciseId';
      preLoaderRoute: typeof AuthenticatedResourcesExercisesExerciseIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/exercises/new': {
      id: '/_authenticated/resources/exercises/new';
      path: '/resources/exercises/new';
      fullPath: '/resources/exercises/new';
      preLoaderRoute: typeof AuthenticatedResourcesExercisesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/meals/': {
      id: '/_authenticated/resources/meals/';
      path: '/resources/meals';
      fullPath: '/resources/meals/';
      preLoaderRoute: typeof AuthenticatedResourcesMealsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/meals/$savedMealId': {
      id: '/_authenticated/resources/meals/$savedMealId';
      path: '/resources/meals/$savedMealId';
      fullPath: '/resources/meals/$savedMealId';
      preLoaderRoute: typeof AuthenticatedResourcesMealsSavedMealIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/meals/new': {
      id: '/_authenticated/resources/meals/new';
      path: '/resources/meals/new';
      fullPath: '/resources/meals/new';
      preLoaderRoute: typeof AuthenticatedResourcesMealsNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/products/': {
      id: '/_authenticated/resources/products/';
      path: '/resources/products';
      fullPath: '/resources/products/';
      preLoaderRoute: typeof AuthenticatedResourcesProductsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/resources/products/new': {
      id: '/_authenticated/resources/products/new';
      path: '/resources/products/new';
      fullPath: '/resources/products/new';
      preLoaderRoute: typeof AuthenticatedResourcesProductsNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/nutrition-plans/': {
      id: '/_authenticated/settings/nutrition-plans/';
      path: '/settings/nutrition-plans';
      fullPath: '/settings/nutrition-plans/';
      preLoaderRoute: typeof AuthenticatedSettingsNutritionPlansIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/nutrition-plans/new': {
      id: '/_authenticated/settings/nutrition-plans/new';
      path: '/settings/nutrition-plans/new';
      fullPath: '/settings/nutrition-plans/new';
      preLoaderRoute: typeof AuthenticatedSettingsNutritionPlansNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/calendar/': {
      id: '/_authenticated/tracking/calendar/';
      path: '/tracking/calendar';
      fullPath: '/tracking/calendar/';
      preLoaderRoute: typeof AuthenticatedTrackingCalendarIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/calendar/week': {
      id: '/_authenticated/tracking/calendar/week';
      path: '/tracking/calendar/week';
      fullPath: '/tracking/calendar/week';
      preLoaderRoute: typeof AuthenticatedTrackingCalendarWeekRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/meals/': {
      id: '/_authenticated/tracking/meals/';
      path: '/tracking/meals';
      fullPath: '/tracking/meals/';
      preLoaderRoute: typeof AuthenticatedTrackingMealsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/meals/manual': {
      id: '/_authenticated/tracking/meals/manual';
      path: '/tracking/meals/manual';
      fullPath: '/tracking/meals/manual';
      preLoaderRoute: typeof AuthenticatedTrackingMealsManualRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/meals/new': {
      id: '/_authenticated/tracking/meals/new';
      path: '/tracking/meals/new';
      fullPath: '/tracking/meals/new';
      preLoaderRoute: typeof AuthenticatedTrackingMealsNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/measurements/': {
      id: '/_authenticated/tracking/measurements/';
      path: '/tracking/measurements';
      fullPath: '/tracking/measurements/';
      preLoaderRoute: typeof AuthenticatedTrackingMeasurementsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/measurements/$bodyMetricId': {
      id: '/_authenticated/tracking/measurements/$bodyMetricId';
      path: '/tracking/measurements/$bodyMetricId';
      fullPath: '/tracking/measurements/$bodyMetricId';
      preLoaderRoute: typeof AuthenticatedTrackingMeasurementsBodyMetricIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/workouts/': {
      id: '/_authenticated/tracking/workouts/';
      path: '/tracking/workouts';
      fullPath: '/tracking/workouts/';
      preLoaderRoute: typeof AuthenticatedTrackingWorkoutsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/workouts/$workoutId': {
      id: '/_authenticated/tracking/workouts/$workoutId';
      path: '/tracking/workouts/$workoutId';
      fullPath: '/tracking/workouts/$workoutId';
      preLoaderRoute: typeof AuthenticatedTrackingWorkoutsWorkoutIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/workouts/active': {
      id: '/_authenticated/tracking/workouts/active';
      path: '/tracking/workouts/active';
      fullPath: '/tracking/workouts/active';
      preLoaderRoute: typeof AuthenticatedTrackingWorkoutsActiveRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/workouts/history': {
      id: '/_authenticated/tracking/workouts/history';
      path: '/tracking/workouts/history';
      fullPath: '/tracking/workouts/history';
      preLoaderRoute: typeof AuthenticatedTrackingWorkoutsHistoryRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/workouts/templates/$templateId': {
      id: '/_authenticated/tracking/workouts/templates/$templateId';
      path: '/tracking/workouts/templates/$templateId';
      fullPath: '/tracking/workouts/templates/$templateId';
      preLoaderRoute: typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/workouts/templates/new': {
      id: '/_authenticated/tracking/workouts/templates/new';
      path: '/tracking/workouts/templates/new';
      fullPath: '/tracking/workouts/templates/new';
      preLoaderRoute: typeof AuthenticatedTrackingWorkoutsTemplatesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/tracking/workouts/templates/$templateId_/edit': {
      id: '/_authenticated/tracking/workouts/templates/$templateId_/edit';
      path: '/tracking/workouts/templates/$templateId/edit';
      fullPath: '/tracking/workouts/templates/$templateId/edit';
      preLoaderRoute: typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute;
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute;
  AuthenticatedPreferencesRoute: typeof AuthenticatedPreferencesRoute;
  AuthenticatedPrivacyAndDataRoute: typeof AuthenticatedPrivacyAndDataRoute;
  AuthenticatedProductsRoute: typeof AuthenticatedProductsRoute;
  AuthenticatedWeightRoute: typeof AuthenticatedWeightRoute;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedAssistantChar123ConversationIdChar125Route: typeof AuthenticatedAssistantChar123ConversationIdChar125Route;
  AuthenticatedMealsNewRoute: typeof AuthenticatedMealsNewRoute;
  AuthenticatedPlansNewRoute: typeof AuthenticatedPlansNewRoute;
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute;
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute;
  AuthenticatedTrackingWeightRoute: typeof AuthenticatedTrackingWeightRoute;
  AuthenticatedPlansIndexRoute: typeof AuthenticatedPlansIndexRoute;
  AuthenticatedResourcesIndexRoute: typeof AuthenticatedResourcesIndexRoute;
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute;
  AuthenticatedTrackingIndexRoute: typeof AuthenticatedTrackingIndexRoute;
  AuthenticatedResourcesExercisesExerciseIdRoute: typeof AuthenticatedResourcesExercisesExerciseIdRoute;
  AuthenticatedResourcesExercisesNewRoute: typeof AuthenticatedResourcesExercisesNewRoute;
  AuthenticatedResourcesMealsSavedMealIdRoute: typeof AuthenticatedResourcesMealsSavedMealIdRoute;
  AuthenticatedResourcesMealsNewRoute: typeof AuthenticatedResourcesMealsNewRoute;
  AuthenticatedResourcesProductsNewRoute: typeof AuthenticatedResourcesProductsNewRoute;
  AuthenticatedSettingsNutritionPlansNewRoute: typeof AuthenticatedSettingsNutritionPlansNewRoute;
  AuthenticatedTrackingCalendarWeekRoute: typeof AuthenticatedTrackingCalendarWeekRoute;
  AuthenticatedTrackingMealsManualRoute: typeof AuthenticatedTrackingMealsManualRoute;
  AuthenticatedTrackingMealsNewRoute: typeof AuthenticatedTrackingMealsNewRoute;
  AuthenticatedTrackingMeasurementsBodyMetricIdRoute: typeof AuthenticatedTrackingMeasurementsBodyMetricIdRoute;
  AuthenticatedTrackingWorkoutsWorkoutIdRoute: typeof AuthenticatedTrackingWorkoutsWorkoutIdRoute;
  AuthenticatedTrackingWorkoutsActiveRoute: typeof AuthenticatedTrackingWorkoutsActiveRoute;
  AuthenticatedTrackingWorkoutsHistoryRoute: typeof AuthenticatedTrackingWorkoutsHistoryRoute;
  AuthenticatedResourcesExercisesIndexRoute: typeof AuthenticatedResourcesExercisesIndexRoute;
  AuthenticatedResourcesMealsIndexRoute: typeof AuthenticatedResourcesMealsIndexRoute;
  AuthenticatedResourcesProductsIndexRoute: typeof AuthenticatedResourcesProductsIndexRoute;
  AuthenticatedSettingsNutritionPlansIndexRoute: typeof AuthenticatedSettingsNutritionPlansIndexRoute;
  AuthenticatedTrackingCalendarIndexRoute: typeof AuthenticatedTrackingCalendarIndexRoute;
  AuthenticatedTrackingMealsIndexRoute: typeof AuthenticatedTrackingMealsIndexRoute;
  AuthenticatedTrackingMeasurementsIndexRoute: typeof AuthenticatedTrackingMeasurementsIndexRoute;
  AuthenticatedTrackingWorkoutsIndexRoute: typeof AuthenticatedTrackingWorkoutsIndexRoute;
  AuthenticatedTrackingWorkoutsTemplatesTemplateIdRoute: typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdRoute;
  AuthenticatedTrackingWorkoutsTemplatesNewRoute: typeof AuthenticatedTrackingWorkoutsTemplatesNewRoute;
  AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRoute: typeof AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedPreferencesRoute: AuthenticatedPreferencesRoute,
  AuthenticatedPrivacyAndDataRoute: AuthenticatedPrivacyAndDataRoute,
  AuthenticatedProductsRoute: AuthenticatedProductsRoute,
  AuthenticatedWeightRoute: AuthenticatedWeightRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAssistantChar123ConversationIdChar125Route:
    AuthenticatedAssistantChar123ConversationIdChar125Route,
  AuthenticatedMealsNewRoute: AuthenticatedMealsNewRoute,
  AuthenticatedPlansNewRoute: AuthenticatedPlansNewRoute,
  AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedTrackingWeightRoute: AuthenticatedTrackingWeightRoute,
  AuthenticatedPlansIndexRoute: AuthenticatedPlansIndexRoute,
  AuthenticatedResourcesIndexRoute: AuthenticatedResourcesIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTrackingIndexRoute: AuthenticatedTrackingIndexRoute,
  AuthenticatedResourcesExercisesExerciseIdRoute:
    AuthenticatedResourcesExercisesExerciseIdRoute,
  AuthenticatedResourcesExercisesNewRoute:
    AuthenticatedResourcesExercisesNewRoute,
  AuthenticatedResourcesMealsSavedMealIdRoute:
    AuthenticatedResourcesMealsSavedMealIdRoute,
  AuthenticatedResourcesMealsNewRoute: AuthenticatedResourcesMealsNewRoute,
  AuthenticatedResourcesProductsNewRoute:
    AuthenticatedResourcesProductsNewRoute,
  AuthenticatedSettingsNutritionPlansNewRoute:
    AuthenticatedSettingsNutritionPlansNewRoute,
  AuthenticatedTrackingCalendarWeekRoute:
    AuthenticatedTrackingCalendarWeekRoute,
  AuthenticatedTrackingMealsManualRoute: AuthenticatedTrackingMealsManualRoute,
  AuthenticatedTrackingMealsNewRoute: AuthenticatedTrackingMealsNewRoute,
  AuthenticatedTrackingMeasurementsBodyMetricIdRoute:
    AuthenticatedTrackingMeasurementsBodyMetricIdRoute,
  AuthenticatedTrackingWorkoutsWorkoutIdRoute:
    AuthenticatedTrackingWorkoutsWorkoutIdRoute,
  AuthenticatedTrackingWorkoutsActiveRoute:
    AuthenticatedTrackingWorkoutsActiveRoute,
  AuthenticatedTrackingWorkoutsHistoryRoute:
    AuthenticatedTrackingWorkoutsHistoryRoute,
  AuthenticatedResourcesExercisesIndexRoute:
    AuthenticatedResourcesExercisesIndexRoute,
  AuthenticatedResourcesMealsIndexRoute: AuthenticatedResourcesMealsIndexRoute,
  AuthenticatedResourcesProductsIndexRoute:
    AuthenticatedResourcesProductsIndexRoute,
  AuthenticatedSettingsNutritionPlansIndexRoute:
    AuthenticatedSettingsNutritionPlansIndexRoute,
  AuthenticatedTrackingCalendarIndexRoute:
    AuthenticatedTrackingCalendarIndexRoute,
  AuthenticatedTrackingMealsIndexRoute: AuthenticatedTrackingMealsIndexRoute,
  AuthenticatedTrackingMeasurementsIndexRoute:
    AuthenticatedTrackingMeasurementsIndexRoute,
  AuthenticatedTrackingWorkoutsIndexRoute:
    AuthenticatedTrackingWorkoutsIndexRoute,
  AuthenticatedTrackingWorkoutsTemplatesTemplateIdRoute:
    AuthenticatedTrackingWorkoutsTemplatesTemplateIdRoute,
  AuthenticatedTrackingWorkoutsTemplatesNewRoute:
    AuthenticatedTrackingWorkoutsTemplatesNewRoute,
  AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRoute:
    AuthenticatedTrackingWorkoutsTemplatesTemplateIdEditRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute;
  PublicLoginRoute: typeof PublicLoginRoute;
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute;
  PublicSignUpRoute: typeof PublicSignUpRoute;
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignUpRoute: PublicSignUpRoute,
};

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
